import * as yup from 'yup';

export const hotelSchema = yup.object().shape({
  email: yup.string().email('El correo electrónico debe ser válido').required('El correo electrónico es obligatorio'),
  name: yup.string().required('El nombre del hotel es obligatorio'),
  contact: yup.string().required('El número de contacto es obligatorio'),
  address: yup.string().required('La dirección es obligatoria'),
  currency: yup.string().required('La moneda es obligatoria'),
  timezone: yup.string().required('La zona horaria es obligatoria')
});
